export default {"src":"/_next/static/media/snack_64.cef06a23.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};